module.exports = __webpack_public_path__ + "img/timeline-arrow.4fd6970f.svg";